export default "__VITE_ASSET__CDNsPwSW__"